import { CodeDetailsData } from "../../../route/public/code/details/page/useDetails";
import { PublicCodeDetails, PublicCodeDetailsMetaTags } from "../components";
import { usePublicCodeDetailsPageTemplate } from "./usePublicCodeDetailsPageTemplate";

interface PublicCodeDetailsPageTemplateProps {
  codeDetailsData?: CodeDetailsData;
}

export const PublicCodeDetailsPageTemplate = ({ codeDetailsData }: PublicCodeDetailsPageTemplateProps): JSX.Element => {
  const {
    standardUuid,
    organisationProjects,
    navigateBackToProject,
    navigateBackToProjectTypesAndStandards,
    showContactUsModal,
    setShowContactUsModal,
  } = usePublicCodeDetailsPageTemplate();
  return (
    <div>
      <PublicCodeDetailsMetaTags codeDetailsData={codeDetailsData} />
      <PublicCodeDetails
        codeDetailsData={codeDetailsData}
        standardUuid={standardUuid}
        organisationProjects={organisationProjects}
        isPreview={false}
        navigateBackToProject={navigateBackToProject}
        navigateBackToCodeComparison={navigateBackToProjectTypesAndStandards}
        showContactUsModal={showContactUsModal}
        setShowContactUsModal={setShowContactUsModal}
      />
    </div>
  );
};
